// A CodeMirror editor (JavaScript mode, line numbers) over a rule's source
// textarea. CodeMirror writes back to the textarea as the form submits.
//
// A textarea inside a hidden tab or a closed <details> has no size yet, so the
// editor refreshes when it becomes visible.
import { Controller } from "@hotwired/stimulus";
import CodeMirror from "codemirror";
import "codemirror/mode/javascript/javascript.js";

export default class CodeEditorController extends Controller<HTMLTextAreaElement> {
  private editor?: CodeMirror.EditorFromTextArea;
  private observer?: IntersectionObserver;

  override connect(): void {
    this.editor = CodeMirror.fromTextArea(this.element, { mode: "javascript", lineNumbers: true, autofocus: false });
    this.observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) this.editor?.refresh();
    });
    this.observer.observe(this.editor.getWrapperElement());
  }

  override disconnect(): void {
    this.observer?.disconnect();
    // toTextArea() tears the editor down and restores the plain textarea, so
    // Turbo's snapshot caches the textarea rather than a dead editor.
    this.editor?.toTextArea();
    this.editor = undefined;
  }
}
